import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["realIndex"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useMutableRef } from '@carnica/utils/hooks';
import { useSwiperInstance } from "./useSwiperInstance";
export var useSwiper = function useSwiper(params) {
  var loop = params.loop,
    autoPlay = params.autoPlay,
    onChangeSlideProp = params.onChangeSlide,
    swiperOptions = params.swiperOptions,
    setIsProgressActive = params.setIsProgressActive,
    _params$originalSlide = params.originalSlidesCount,
    originalSlidesCount = _params$originalSlide === void 0 ? 1 : _params$originalSlide,
    onSwiperInitProp = params.onSwiperInit;
  var speed = (swiperOptions === null || swiperOptions === void 0 ? void 0 : swiperOptions.speed) || 1500;
  var onChangeSlide = useMutableRef(onChangeSlideProp);
  var loopRef = useMutableRef(loop);
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    activeSlide = _useState2[0],
    setActiveSlide = _useState2[1];
  var activeSlideRef = useMutableRef(activeSlide);
  var isProgressChangingRef = useRef(false);
  var delayOnChangeSlide = function delayOnChangeSlide() {
    setIsProgressActive(false);
    setTimeout(function () {
      setIsProgressActive(true);
      isProgressChangingRef.current = false;
    }, speed);
  };
  var updateControlListeners = function updateControlListeners(type) {
    var updateListeners = function updateListeners(node) {
      node === null || node === void 0 ? void 0 : node[type === 'add' ? 'addEventListener' : 'removeEventListener']('click', delayOnChangeSlide);
    };
    updateListeners(nextControlRef.current);
    updateListeners(prevControlRef.current);
  };
  var onSlideChange = useCallback(function (_ref) {
    var _swiperOptions$on, _swiperOptions$on$sli, _onChangeSlide$curren;
    var realIndex = _ref.realIndex,
      otherParams = _objectWithoutProperties(_ref, _excluded);
    var virtualIndex = realIndex % originalSlidesCount;
    swiperOptions === null || swiperOptions === void 0 ? void 0 : (_swiperOptions$on = swiperOptions.on) === null || _swiperOptions$on === void 0 ? void 0 : (_swiperOptions$on$sli = _swiperOptions$on.slideChange) === null || _swiperOptions$on$sli === void 0 ? void 0 : _swiperOptions$on$sli.call(_swiperOptions$on, _objectSpread({
      realIndex: virtualIndex
    }, otherParams));
    var slide = virtualIndex + 1;
    var currentSlide = activeSlideRef.current;
    if (currentSlide !== slide) {
      setActiveSlide(slide);
    }
    if (currentSlide === slide || isProgressChangingRef.current) {
      return;
    }
    (_onChangeSlide$curren = onChangeSlide.current) === null || _onChangeSlide$curren === void 0 ? void 0 : _onChangeSlide$curren.call(onChangeSlide, slide);
    if (autoPlay) {
      delayOnChangeSlide();
    }
  }, []);
  var onTouchStart = useCallback(function () {
    var _swiperOptions$on2, _swiperOptions$on2$to;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    swiperOptions === null || swiperOptions === void 0 ? void 0 : (_swiperOptions$on2 = swiperOptions.on) === null || _swiperOptions$on2 === void 0 ? void 0 : (_swiperOptions$on2$to = _swiperOptions$on2.touchStart) === null || _swiperOptions$on2$to === void 0 ? void 0 : _swiperOptions$on2$to.call.apply(_swiperOptions$on2$to, [_swiperOptions$on2].concat(args));
    if (autoPlay) {
      setIsProgressActive(false);
    }
  }, [autoPlay]);
  var onTouchEnd = useCallback(function () {
    var _swiperOptions$on3, _swiperOptions$on3$to;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    swiperOptions === null || swiperOptions === void 0 ? void 0 : (_swiperOptions$on3 = swiperOptions.on) === null || _swiperOptions$on3 === void 0 ? void 0 : (_swiperOptions$on3$to = _swiperOptions$on3.touchEnd) === null || _swiperOptions$on3$to === void 0 ? void 0 : _swiperOptions$on3$to.call.apply(_swiperOptions$on3$to, [_swiperOptions$on3].concat(args));
    if (autoPlay) {
      setTimeout(function () {
        setIsProgressActive(true);
      }, speed);
    }
  }, [autoPlay]);
  var onSwiperInit = useCallback(function (swiper) {
    setActiveSlide(1);
    updateControlListeners('add');
    onSwiperInitProp === null || onSwiperInitProp === void 0 ? void 0 : onSwiperInitProp(swiper);
    swiper.on('touchEnd', onTouchEnd);
    swiper.on('touchStart', onTouchStart);
    swiper.on('slideChange', onSlideChange);
  }, [onSwiperInitProp]);
  var _useSwiperInstance = useSwiperInstance(_objectSpread(_objectSpread({}, params), {}, {
      onSwiperInit: onSwiperInit
    })),
    swiperNodeRef = _useSwiperInstance.swiperNodeRef,
    swiper = _useSwiperInstance.swiper,
    nextControlRef = _useSwiperInstance.nextControlRef,
    prevControlRef = _useSwiperInstance.prevControlRef;
  var changeSwiperSlide = function changeSwiperSlide(slide) {
    if (!slide) {
      return;
    }
    isProgressChangingRef.current = true;
    delayOnChangeSlide();
    if (loopRef.current) {
      var _swiper$current;
      (_swiper$current = swiper.current) === null || _swiper$current === void 0 ? void 0 : _swiper$current[slide + 1 === activeSlideRef.current ? 'slidePrev' : 'slideNext'](speed, false);
    } else {
      var _swiper$current2;
      (_swiper$current2 = swiper.current) === null || _swiper$current2 === void 0 ? void 0 : _swiper$current2.slideTo(slide - 1, speed, false);
    }
  };
  useEffect(function () {
    return function () {
      updateControlListeners('remove');
    };
  }, [loop, autoPlay, swiperOptions]);
  return useMemo(function () {
    return {
      swiperNodeRef: swiperNodeRef,
      changeSwiperSlide: changeSwiperSlide,
      activeSlide: activeSlide,
      nextControlRef: nextControlRef,
      swiper: swiper,
      prevControlRef: prevControlRef
    };
  }, [activeSlide]);
};